module.exports = __webpack_public_path__ + "static/media/default_cantine_menue_image.bd77fead.png";